import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="google-form"
export default class extends Controller {
  static targets = ['form', 'status', 'submitButton'];
  static values = { action: String };

  async submit(event) {
    event.preventDefault();

    if (!this.hasFormTarget) return;

    const form = this.formTarget;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    this.setSubmitting(true);
    this.hideStatus();

    try {
      await fetch(this.actionValue || form.action, {
        method: 'POST',
        mode: 'no-cors',
        body: new FormData(form)
      });

      form.reset();
      this.showStatus(this.statusMessage('success'), false);
    } catch (_error) {
      this.showStatus(this.statusMessage('error'), true);
    } finally {
      this.setSubmitting(false);
    }
  }

  setSubmitting(isSubmitting) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = isSubmitting;
    }
  }

  showStatus(message, isError) {
    if (!this.hasStatusTarget) return;

    this.statusTarget.hidden = false;
    this.statusTarget.textContent = message;
    this.statusTarget.classList.toggle('google-form__status--error', isError);
  }

  hideStatus() {
    if (!this.hasStatusTarget) return;
    this.statusTarget.hidden = true;
    this.statusTarget.textContent = '';
  }

  statusMessage(kind) {
    return this.element.dataset[`googleForm${kind[0].toUpperCase()}${kind.slice(1)}Message`] ||
      (kind === 'success' ? 'Submitted.' : 'Submission failed.');
  }
}
